import { makeAutoObservable } from 'mobx'

import { Collection } from '@flowwai-frontend/shared/sales-crm/sales-crm-core'

import ChatConfigModel from '../models/ChatConfigModel'

class ChatConfigStore {
   private _chatConfigsCollection!: Collection<string, ChatConfigModel>

   private constructor() {
      this.init()

      makeAutoObservable(this, {}, { autoBind: true })
   }

   private init(): void {
      this._chatConfigsCollection = new Collection<string, ChatConfigModel>(
         "The ChatConfig you are trying to access doesn't exist"
      )
   }

   get chatConfigs(): Array<ChatConfigModel> {
      return this._chatConfigsCollection.orderedItems
   }

   addChatConfig = (chatConfig: ChatConfigModel, index?: number): void => {
      this._chatConfigsCollection.addItem(chatConfig.chatId, chatConfig, index)
   }

   getChatConfig = (chatId: string): ChatConfigModel =>
      this._chatConfigsCollection.getItem(chatId)

   hasChatConfig = (chatId: string): boolean =>
      this._chatConfigsCollection.hasItem(chatId)

   deleteChatConfig = (chatId: string): void => {
      this._chatConfigsCollection.deleteItem(chatId)
   }

   clearStore = (): void => {
      this.init()
   }

   static create = (): ChatConfigStore => new ChatConfigStore()
}

export default ChatConfigStore
